import { String } from 'app/shared/domain/value-objects/string';
import { t } from 'i18next';
import {
    ENGLISH_LANGUAGE,
    FRENCH_LANGUAGE,
    GERMAN_LANGUAGE,
    ITALIAN_LANGUAGE,
    SPANISH_LANGUAGE,
} from '../../../../../i18n/translations/TR';

export class TranslationLanguage extends String {

    public translate(): string {
        switch (this.value) {
            case 'es':
                return t(SPANISH_LANGUAGE);
            case 'en':
                return t(ENGLISH_LANGUAGE);
            case 'fr':
                return t(FRENCH_LANGUAGE);
            case 'it':
                return t(ITALIAN_LANGUAGE);
            case 'de':
                return t(GERMAN_LANGUAGE);
            default:
                return '';
        }
    }

}
